$(document).ready(function(){

  $(document).on('click','#checkout-button',function(){

    $('#checkout-button').addClass("loading");
    
    var medrep = $.trim($('#dropdown-cart').text());
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var updateData = {
        note: 'Medical Representative: \r\n' + medrep + '\r\n\r\nInstruction: \r\n' + document.getElementById('CartDrawer-Note').value
      };
      
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(updateData)
      })
      .then(response => response.json())
      .then(cart => {
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error updating cart note:', error);
      });
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
  })
});



